import { Button, useModal } from "@shortsworks/ui";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setAuthToken,
  TokenResponse,
  useRegisterAccount,
  useSignIn,
} from "@shortsworks/user-api";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { Children } from "react";
import FormContainer from "@app/components/forms/container/FormContainer";
import { PriceAgreementSchema } from "@app/pages/auth/Signup/priceAgreementSchema";

export const PriceAgreementForm = () => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const location = useLocation();

  const registerAccount = useRegisterAccount();
  const signin = useSignIn();

  const pricingInfo = [
    {
      title: "동영상",
      desc: "무제한",
    },
    {
      title: "이미지",
      desc: "무제한",
    },
    {
      title: "트래픽",
      desc: `500GB`,
    },
    {
      title: "스토리지",
      desc: " 무제한",
    },
    {
      title: "가격(월간)",
      desc: `61,000원`,
    },
    {
      title: "가격(일간)",
      desc: `약 2000원`,
    },
    {
      title: "설치비",
      desc: "한시적 무료",
    },
  ];

  const { form, schemas, parseForm } = useFormWithSchema({
    formSchemas: PriceAgreementSchema,
    mode: "onChange",
  });

  const goPrevious = () => {
    return navigate("/signup/step4");
  };

  const goNext = async () => {
    const parsedForm = parseForm();
    if (!parsedForm.success) {
      return showModal(CommonErrorModal, { title: "회원가입을 위해 모두 동의해주세요." });
    }

    // todo: 미동의 발생 시, 문구 색상 변경을 통한 알림 필요
    const hasFalseValue = Object.values(parsedForm.data).includes(false);
    if(hasFalseValue) {
      return showModal(CommonErrorModal, { title: "회원가입을 위해 모두 동의해주세요." });
    }

    try {
      const result = await registerAccount.mutateAsync({
        data: {
          destination: "",
          username: location.state.platformName,
          ...location.state,
          userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      });

      if (result.error) {
        return showModal(CommonErrorModal, {
          title: "회원가입에 실패했습니다.",
        });
      }

      // 에러 처리 필요
      const login: TokenResponse = await signin.mutateAsync({
        data: {
          email: location.state.userId,
          password: location.state.password,
        },
      });

      setAuthToken({
        // @ts-ignore
        accessToken: login.data.accessToken,
        // @ts-ignore
        refreshToken: login.data.refreshToken,
      });

      return navigate("/signup/step6", {
        state: location.state,
      });
    } catch (error) {
      return showModal(CommonErrorModal, { title: "회원가입에 실패했습니다." });
    }
  };

  return (
    <div>
      <div className="text-xl font-bold mb-8">가격 안내</div>
      <div className="mb-8 flex flex-col gap-4">
        {Children.toArray(
          pricingInfo.map(({ title, desc }) => {
            return (
              <div className="flex flex-row w-full justify-between">
                <div>{title}</div>
                <div>{desc}</div>
              </div>
            );
          }),
        )}
      </div>

      <div className="flex flex-col mb-8 text-sm gap-2 font-light">
        <div>
          * 위 금액은 매월 결제되며, VAT(부가세)가 포함되지 않은 금액입니다.
        </div>
        <div>
          * 초과되는 트래픽의 1TB 이내 사용량은 1GB당 100원, 1TB 초과 사용량은
          1GB당 90원이 부과됩니다.
        </div>
        <div>
          * 위젯의 커스터마이징이 필요한 경우는 추가요금이 부과될 수 있습니다.
        </div>
        <div>
          * 월간 방문자수가 10만명 이상인 경우 니즈에 맞도록 별도의 요금제를
          설계해드립니다.
        </div>
      </div>

      <FormContainer schemas={schemas} form={form} />
      <div className="mt-3 font-light text-sm">
        * 가입일로부터 1개월 이내, 트래픽 500GB까지 무료체험이 가능합니다.
        트래픽을 모두 소진시 구독여부를 선택하실 수 있습니다.
      </div>
      <div className="flex flex-row w-full">
        <Button
          className="w-full mr-4"
          variant="secondary"
          onClick={goPrevious}
        >
          이전
        </Button>
        <Button className="w-full" onClick={goNext}>
          다음
        </Button>
      </div>
    </div>
  );
};
